import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextInput";
import PhoneNumberField from "../Reusable/PhoneNumberField";

const CustomerForm = ({
  register,
  errors,
  setValue,
  clearErrors,
  control,
}: any) => {
  return (
    <div className={tw`grid grid-cols-2 md:grid-cols-2 gap-x-4 mx-4`}>
      <TextField
        label={"Full Name"}
        register={register("full_name")}
        errors={errors?.full_name}
      />
      <TextField
        label={"Email"}
        register={register("email")}
        errors={errors?.email}
      />
      <PhoneNumberField
        control={control}
        label={"Mobile Number"}
        name={"primary_contact"}
        errors={errors?.primary_contact}
      />
      <PhoneNumberField
        control={control}
        label={"Alt Number"}
        name={"secondary_contact"}
        errors={errors?.secondary_contact}
      />
      <TextField
        label={"Full Address"}
        register={register("address")}
        errors={errors?.address}
      />
      <TextField
        label={"VAT/PAN"}
        register={register("vat_pan")}
        errors={errors?.vat_pan}
      />
    </div>
  );
};

export default CustomerForm;
